import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, Inject, PLATFORM_ID, LOCALE_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute, Params, ParamMap } from '@angular/router';
import { Simpleformservice } from './simpleforms.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { environment } from '../../environments/environment';
import { Page, Settings } from '../shared/navigation/pages.model';
import { BehaviorSubject, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { UtilsService } from '../shared/services/utils.service';
import { utils } from '../shared/helpers/utils';
import { FileItem, FileUploader, ParsedResponseHeaders } from 'ng2-file-upload';

@Component({
  selector: 'app-simpleforms',
  templateUrl: 'simpleforms.component.html',
  styleUrls: ['simpleforms.component.scss'],
  animations: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class SimpleformsComponent implements OnInit, OnDestroy {

  public page: BehaviorSubject<Page> = new BehaviorSubject(new Page);
  public cdn = environment.cdn;
  public settings: Settings = new Settings;
  public countries = utils.countries;

  public loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public sent: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public result:string;
  public resultMessage:string;
  public form: FormGroup;
  public form_name = '';
  public came_from = '-';

  public uploader: FileUploader = new FileUploader({});
  public uploaded: BehaviorSubject<string[]> = new BehaviorSubject([]);
  public errored: BehaviorSubject<string[]> = new BehaviorSubject([]);
  public hasBaseDropZoneOver = false;
  public photoExtensions = ['jpg', 'png'];
  public filesExtensions = ['txt', 'pdf', 'docx', 'doc', 'xls', 'xlsx', 'rtx'];
  public dir = 'generate';
  public loading_file: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public path_rules = '';

  constructor(@Inject(LOCALE_ID) public localeId: string, private router: Router, private route: ActivatedRoute, private fb: FormBuilder, private simpleformsService: Simpleformservice,
    private navigationService: NavigationService, private utilsService: UtilsService, private cdr: ChangeDetectorRef) {
    }

  ngOnInit() {
    if (this.route.snapshot?.data?.extra_field_3 == 'toolbox_rules') {
      this.form_name = 'Formularz skrzynki';
    } else if (this.route.snapshot?.data?.extra_field_3 == 'register_product_rules') {
      this.form_name = 'Formularz rejestracji produktu';
    }
    this.route.paramMap.pipe(take(1)).subscribe((params: ParamMap) => {
        this.navigationService.item(this.route.snapshot.data.id).pipe(take(1)).subscribe((p: any) => {
          this.page.next(p);
          this.path_rules = this.router.config.find(x => x.data?.template === p.extra_field_3)?.path || '';
      });
      this.createForm();
      this.setOptions();
      this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
      this.uploader.onCompleteAll = () => this.onCompleteAll();
    });
    
  }

  createForm() {
    let default_country = this.countries.find(c => c.value == this.localeId.toUpperCase())?.value || 'Polska';
    this.form = this.fb.group({
      name: ['', Validators.required],
      surname: ['', Validators.required],
      email: ['', Validators.required],

      company: [''],
      phone: ['', [Validators.required]],

      street: ['', Validators.required],
      building: ['', Validators.required],
      flat: [''],
      postcode: ['', [Validators.required]],
      city: ['', Validators.required],
      country: [default_country, Validators.required],

      extra_1: ['', Validators.required],
      extra_2: ['', Validators.required],
      filename: [''],
      token: ['true'],
      rodo: ['', Validators.requiredTrue],
      rodo1: ['', Validators.requiredTrue],

      form_name: [this.form_name],
      click: [this.navigationService.getClickId().value?.click]
    });

    const countryCtrl = this.form.get('country');
    const phoneCtrl = this.form.get('phone');

    countryCtrl.valueChanges.subscribe((c: string) => {
      if (c === 'Polska') {
        phoneCtrl.setValidators([Validators.required, Validators.minLength(9), Validators.maxLength(9)]);
      } else {
        phoneCtrl.setValidators([Validators.required]);
      }
      phoneCtrl.updateValueAndValidity();
    });
  }

  submit() {
    if (this.form.status === 'VALID' && this.uploaded.value.length > 0) {
      this.loading.next(true);
      const formModel = this.form.value;
      this.simpleformsService.save(formModel).subscribe((result: any) => {
        this.sent.next(true);
        this.result = result.type;
        this.resultMessage = result.message;
        if (result.type == 'success') {
          this.utilsService.gtmCustom('form_submit', {form_name: 'Simple form'})
        } else {
          this.utilsService.gtmCustom('form_submit_error', {form_name: 'Simple form'})
        }
        this.loading.next(false);
      }, error => {
        this.result = 'error';
        this.resultMessage = 'Wystąpił nieznany błąd - spróbuj ponownie.';
        this.loading.next(false);
        this.utilsService.gtmCustom('form_submit_error', {form_name: 'Simple form'})
      }
      );
    } else {
      // if (!this.form.controls.rodo.valid) {
        this.form.controls.rodo.markAsDirty();
      // }
    }
  }

  setOptions() {
    const token = localStorage.getItem('user_token');
    const options = {
      url: environment.api + '/upload',
      // authToken: 'Bearer ' + token,
      additionalParameter: { module: 'simpleforms', dir: 'product_register', limit: 1, miniatures: {} },
      queueLimit: 1
    };
    this.uploader.setOptions(options); //  = new FileUploader(options);
  }

  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    const res = JSON.parse(response);

    if (res.message === 'error') {
      let error = '';
      switch(+res.upload_code) {
        case 1:
        case 2:
          error =  $localize `:@@upload_error_1:Maksymalny rozmiar pliku został przekroczony`;
          break;
        case 3:
          error =  $localize `:@@upload_error_2:Twój plik został wgrany częściowo - spróbuj ponownie`;
          break;
        case 4:
          error =  $localize `:@@upload_error_3:Pliku nie udało się przesłać`;
          break;
        case 6:
        case 7:
        case 8:
          error =  $localize `:@@upload_error_4:Nie udało się zapisać pliku - skontaktuj się z nami e-mailowo`;
          break;
      }
      this.errored.next([...this.errored.getValue(), item.file.name]);
    } else {
      this.uploaded.next([...this.uploaded.getValue(), item.file.name]);
      this.form.controls.filename.setValue(res.filename);
    }
  }

  onCompleteAll() {
    this.loading_file.next(false);
    this.uploader.clearQueue();
  }

  fileDropped(e: any): void {
      this.loading_file.next(true);
      this.uploader.uploadAll();
  }

  ngOnDestroy() {
    // if (this.sub) {
    //   this.sub.unsubscribe();
    // }
  }

}
